import React, { useState, useEffect } from "react";
import { sendGetRequest, sendGetRequestApi } from "../../services/service";
import { config } from "../../config/dev";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
  CardText,
  Alert,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Button,
  Modal,
} from "reactstrap";
import classnames from "classnames";
import { log_debug } from "../../helpers/logger";
import {
  updateBehavioural,
  updateCoding,
  updateMcq,
} from "../../store/api/patchApi/patchApiSlice";
import { useDispatch } from "react-redux";
import { getBehavioural, getCoding, getMcq } from "../../store/api/getApi/getApiSlice";
import { toast, ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";
import { deleteBehavioural, deleteCoding, deleteMcq } from "../../store/api/deleteApi/deleteApiSlice";

const McqOffCanvas = ({ isOpen, toggleRightCanvas, mcqData, type,handleToast }) => {
  const dispatch = useDispatch();

  const [canvasData, setMcqData] = useState({});
  const [modal_backdrop, setmodal_backdrop] = useState(false);

  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop);
    removeBodyCss();
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  useEffect(() => {
    log_debug("selectedMcqdata", "McqSection", JSON.stringify(mcqData));
    setMcqData(mcqData);
  }, [mcqData]);

  const handleStatusChange = (id, status) => {
    if (type === "mcq") {
      if (status === "active") {
        dispatch(updateMcq({ status, id })).then((res) => {
          if (res?.payload?.success === true) {
            toast.success("Status Updated Successfully");
            setMcqData(res?.payload?.data);
            // toggleRightCanvas();
            dispatch(getMcq({ currentPage: 0 }));
          }
        });
      } else if (status === "inactive") {
        dispatch(updateMcq({ status, id })).then((res) => {
          if (res?.payload?.success === true) {
            toast.success("Status Updated Successfully");
            setMcqData(res?.payload?.data);
            // toggleRightCanvas()
            dispatch(getMcq({ currentPage: 0 }));
          }
        });
      }
    } else if (type === "coding") {
      if (status === "active") {
        dispatch(updateCoding({ status, id })).then((res) => {
          if (res?.payload?.success === true) {
            toast.success("Status Updated Successfully");
            setMcqData(res?.payload?.data);
            // toggleRightCanvas();
            dispatch(getCoding({ currentPage: 0 }));
          }
        });
      } else if (status === "inactive") {
        dispatch(updateCoding({ status, id })).then((res) => {
          if (res?.payload?.success === true) {
            toast.success("Status Updated Successfully");
            setMcqData(res?.payload?.data);
            // toggleRightCanvas()
            dispatch(getCoding({ currentPage: 0 }));
          }
        });
      }
    }else{
      if (status === "active") {
        dispatch(updateBehavioural({ status, id })).then((res) => {
          if (res?.payload?.success === true) {
            toast.success("Status Updated Successfully");
            setMcqData(res?.payload?.data);
            // toggleRightCanvas();
            dispatch(getBehavioural({ currentPage: 0 }));
          }
        });
      } else if (status === "inactive") {
        dispatch(updateBehavioural({ status, id })).then((res) => {
          if (res?.payload?.success === true) {
            toast.success("Status Updated Successfully");
            setMcqData(res?.payload?.data);
            // toggleRightCanvas()
            dispatch(getBehavioural({ currentPage: 0 }));
          }
        });
      }
    }
  };


  const handleDeleteRecord = (id) => {
    if(type === "mcq"){
      dispatch(deleteMcq({ id })).then((res) => {
        if (res?.payload?.success === true) {
          setMcqData(res?.payload?.data);
          dispatch(getMcq({ currentPage: 0 }));
          handleToast({status : "Record deleted successfully"})
        }
      });
    }else if(type === "coding"){
      dispatch(deleteCoding({ id })).then((res) => {
        if (res?.payload?.success === true) {
          dispatch(getCoding({ currentPage: 0 }));
          setMcqData(res?.payload?.data);
          handleToast({status : "Record deleted successfully"})
        }
      });
    }else {
      dispatch(deleteBehavioural({ id })).then((res) => {
        if (res?.payload?.success === true) {
          dispatch(getBehavioural({ currentPage: 0 }));
          setMcqData(res?.payload?.data);
          handleToast({status : "Record deleted successfully"})
        }
      });
    }
  }

  return (
    <React.Fragment>
      <div>
        <Offcanvas
          style={{ width: "50%", zoom: "100%" }}
          isOpen={isOpen}
          direction="end"
        >
          <OffcanvasHeader className="border-bottom" toggle={toggleRightCanvas}>
            <h6 className="text-primary font-size-14">
              Question Details{"  "}
              <span className="font-size-12 text-muted ">
                <i className="mdi mdi-information font-size-13 mt-2" /> Question
                Details displayed, Relevant information for the selected
                question
              </span>
            </h6>
          </OffcanvasHeader>
          <OffcanvasBody>
            {type === "mcq" ? (
              <Card>
                <CardHeader>
                  <Row>
                    <Col lg={9} className="my-auto">
                      <h6>{canvasData?.question}</h6>
                    </Col>
                    <Col lg={2} className="text-end my-auto">
                      <span className="badge bg-primary">
                        {canvasData?.category}
                      </span>
                    </Col>
                    <Col lg={1} className="text-end">
                      <Button
                        color="danger"
                        onClick={() => {
                          tog_backdrop();
                        }}
                      >
                        <i className=" fas fa-trash-alt text-white" />
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <ul>
                    {canvasData?.answers &&
                      canvasData?.answers.map((answer, index) => (
                        <li
                          style={{ listStyleType: "none" }}
                          className={`fw-bold `}
                          key={index}
                        >
                          <div
                            className={`d-flex border rounded ${answer && answer.split(")")[0] === canvasData?.correctAnswer ? "bg-success bg-opacity-25 text-success" : ""}`}
                          >
                            <div className="m-2">
                              <Button
                                color={
                                  answer && answer.split(")")[0] === canvasData?.correctAnswer
                                    ? "success"
                                    : "light"
                                }
                              >
                                {answer && answer.split(")")[0]}
                              </Button>
                            </div>

                            <div className="my-auto">{answer && answer.split(")")[1]}</div>
                          </div>
                        </li>
                      ))}
                  </ul>
                </CardBody>
                <CardFooter className="bg-light">
                  <Row>
                    <Col lg={8}>
                      <h6>
                        {"Correct Answer : "}{" "}
                        <span className="badge bg-success-subtle text-success fs-6">
                          {canvasData?.correctAnswer}
                        </span>
                      </h6>
                    </Col>
                    <Col lg={4}>
                      <div className="font-size-15 text-end">
                        <span className="fw-bold">Status : </span>
                        <span
                          className={`fw-bold badge ${canvasData?.status === "draft" ? "bg-warning" : canvasData?.status === "active" ? "bg-success" : "bg-danger"} `}
                        >
                          {canvasData?.status}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            ) : type === "coding" ? (
              <Card>
                <CardHeader>
                <Row>
                    <Col lg={9} className="my-auto">
                      <h6>{canvasData?.question}</h6>
                    </Col>
                    <Col lg={2} className="text-end my-auto">
                      <span className="badge bg-primary">
                        {canvasData?.category}
                      </span>
                    </Col>
                    <Col lg={1} className="text-end">
                      <Button
                        color="danger"
                        onClick={() => {
                          tog_backdrop();
                        }}
                      >
                        <i className=" fas fa-trash-alt text-white" />
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="p-3">
                  {/* <div>
                    <p className="fw-bold mb-0">Required Skills </p>
                    <p>
                      {canvasData?.skillTags &&
                        canvasData?.skillTags.map((skill, index) => (
                          <span key={index} className="badge bg-primary ms-1">
                            {skill}
                          </span>
                        ))}
                    </p>
                  </div> */}
                  <p className="mb-0 fw-bold">Constraints</p>
                  <p className="text-secondary">{canvasData?.constraints}</p>

                  <p className="mb-0 fw-bold">Example</p>
                  <ol>
                    {canvasData?.example &&
                      canvasData?.example.map((answer, index) => (
                        <li key={index}>
                          <div className={`d-flex`}>
                            <div className="my-auto">
                              <p className="m-0 fw-bold">Input</p>
                              <p>{answer?.input}</p>
                              <p className="m-0 fw-bold">Output</p>
                              <p>{answer?.output}</p>
                              <p className="m-0 fw-bold">Explanation</p>
                              <p>{answer?.explanation}</p>
                            </div>
                          </div>
                        </li>
                      ))}
                  </ol>
                  <div className="text-end">
                    <span className="fw-bold">Status: </span>
                    <span
                      className={`badge ${canvasData?.status === "draft" ? "bg-warning" : canvasData?.status === "active" ? "bg-success" : "bg-danger"}`}
                    >
                      {canvasData?.status}
                    </span>
                  </div>
                </CardBody>
              </Card>
            ) : (
              <Card>
                <CardHeader>
                <Row>
                    <Col lg={9} className="my-auto">
                      <h6>{canvasData?.question}</h6>
                    </Col>
                    <Col lg={2} className="text-end my-auto">
                      <span className="badge bg-primary">
                        {canvasData?.category}
                      </span>
                    </Col>
                    <Col lg={1} className="text-end">
                      <Button
                        color="danger"
                        onClick={() => {
                          tog_backdrop();
                        }}
                      >
                        <i className=" fas fa-trash-alt text-white" />
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div>
                    <p className="fw-bold mb-0">Required Skills </p>
                    <p>
                      {canvasData?.skillTags &&
                        canvasData?.skillTags.map((skill, index) => (
                          <span key={index} className="badge bg-primary ms-1">
                            {skill}
                          </span>
                        ))}
                    </p>
                  </div>
                  <div className="text-end">
                    <span className="fw-bold">Status: </span>
                    <span
                      className={`badge ${canvasData?.status === "draft" ? "bg-warning" : canvasData?.status === "active" ? "bg-success" : "bg-danger"}`}
                    >
                      {canvasData?.status}
                    </span>
                  </div>
                </CardBody>
              </Card>
            )}
            {canvasData?.status === "draft" ? (
              <div className="d-flex flex-row-reverse flex-wrap gap-2">
                <button
                  type="button"
                  className="btn btn-danger waves-effect btn-label waves-light"
                  onClick={() =>
                    handleStatusChange(canvasData?._id, "inactive")
                  }
                >
                  <i className="bx bx-x label-icon"></i> Reject
                </button>
                <button
                  type="button"
                  className="btn btn-success waves-effect btn-label waves-light"
                  onClick={() => handleStatusChange(canvasData?._id, "active")}
                >
                  <i className="bx bx-check label-icon"></i> Approve
                </button>
              </div>
            ) : (
              <div className="d-flex flex-row-reverse flex-wrap gap-2">
                <button
                  type="button"
                  className="btn btn-danger waves-effect btn-label waves-light"
                  disabled={canvasData?.status === "inactive"}
                  onClick={() =>
                    handleStatusChange(canvasData?._id, "inactive")
                  }
                >
                  <i className="bx bx-x label-icon"></i> Inactive
                </button>
                <button
                  type="button"
                  className="btn btn-success waves-effect btn-label waves-light"
                  disabled={canvasData?.status === "active"}
                  onClick={() => handleStatusChange(canvasData?._id, "active")}
                >
                  <i className="bx bx-check label-icon"></i> Active
                </button>
              </div>
            )}
          </OffcanvasBody>
        </Offcanvas>
      </div>

      <Modal
        isOpen={modal_backdrop}
        toggle={() => {
          tog_backdrop();
        }}
        backdrop={"static"}
        id="staticBackdrop"
      >
        {/* <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            Modal title
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              setmodal_backdrop(false);
            }}
            aria-label="Close"
          ></button>
        </div> */}
        <div className="modal-body text-center">
          <h4>Are you sure?</h4>
          <p className="mb-0">Do you really want to delete this record? This process cannot be undone.</p>
        </div>
        <div className="modal-footer justify-center">
        <button type="button" className="btn btn-danger" onClick={() => handleDeleteRecord(canvasData?._id)}>
            Yes
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => {
              setmodal_backdrop(false);
            }}
          >
            No
          </button>
          
        </div>
      </Modal>

    </React.Fragment>
  );
};

export default McqOffCanvas;
